import type { NeedHelpMailRequest, OrderRequest } from '~/types/api'
export function createMailRepository() {
  const { $api } = useNuxtApp()
  const { post } = baseRepository($api)

  const DOMAIN = 'mails'
  const DOMAIN_HELP = 'need-help'

  async function sendNeedHelp(body: NeedHelpMailRequest) {
    return post<unknown>([DOMAIN, DOMAIN_HELP], { body })
  }

  return {
    sendNeedHelp,
  }
}
